import { render, staticRenderFns } from "./mdBackQueryShSh.vue?vue&type=template&id=35a0fa0c&scoped=true"
import script from "./mdBackQueryShSh.vue?vue&type=script&lang=js"
export * from "./mdBackQueryShSh.vue?vue&type=script&lang=js"
import style0 from "./mdBackQueryShSh.vue?vue&type=style&index=0&id=35a0fa0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0fa0c",
  null
  
)

export default component.exports